import { Component, inject, Input } from '@angular/core';
import { Doctor } from '../../models/doctor.model';
import { Patient } from '../../models/patient.model';
import { Call } from '../../models/call.model';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'app-doctor-card',
  templateUrl: './doctor-card.component.html',
  styleUrls: ['./doctor-card.component.css'],
  standalone: false
})
export class DoctorCardComponent {
  private readonly localeService = inject(LocaleService);
  
  @Input() doctor: Doctor;
  @Input() patient: Patient;
  @Input() call: Call;

  get locale(): string {
    return this.localeService.getLocale();
  }
}
